import { render } from "./KeeperYear1.vue?vue&type=template&id=0e417864"
import script from "./KeeperYear1.vue?vue&type=script&lang=js"
export * from "./KeeperYear1.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__